<div class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0" style="background: #1e1e1e;">
    <h4 class="modal-title" style="color: #ffffff; font-weight: 700;">
      <i class="fa-solid fa-circle-question me-2" style="color: #00a8ff;"></i> Login Assistance
    </h4>
    <button type="button" class="close-btn" (click)="modalRef.hide()">
      <i class="fa-solid fa-xmark"></i>
    </button>
</div>

<div class="modal-body pb-4" style="background: #1e1e1e; color: #e0e0e0;">
    <p class="mb-4 text-light" style="font-size: 1.1rem; border-bottom: 1px solid rgba(255, 255, 255, 0.05); padding-bottom: 10px;">
        Are you having problems logging in?
    </p>

    <!-- Account Owners -->
    <div class="mb-3 d-flex align-items-start gap-3">
        <i class="fa-solid fa-user-shield mt-1" style="color: #00a8ff;"></i>
        <div>
            <strong style="color: #ffffff; display: block; margin-bottom: 4px;">For Account Owners</strong>
            <p style="color: rgba(255, 255, 255, 0.7); font-size: 14px; line-height: 1.5;">
                Your Username is the email address used when you first signed up, unless you have manually updated it within the system settings.
            </p>
        </div>
    </div>

    <!-- Staff Users -->
    <div class="mb-3 d-flex align-items-start gap-3">
        <i class="fa-solid fa-users mt-1" style="color: #00a8ff;"></i>
        <div>
            <strong style="color: #ffffff; display: block; margin-bottom: 4px;">For Staff Members</strong>
            <p style="color: rgba(255, 255, 255, 0.7); font-size: 14px; line-height: 1.5;">
                Staff accounts may need to contact their system manager/administrator to reset login credentials via the User Management dashboard.
            </p>
        </div>
    </div>

    <!-- Contact Support -->
    <div class="mt-4 p-3" style="background: rgba(0, 168, 255, 0.05); border: 1px solid rgba(0, 168, 255, 0.1); border-radius: 12px;">
        <div class="d-flex align-items-start gap-3">
            <i class="fa-solid fa-phone mt-1" style="color: #00a8ff;"></i>
            <div>
                <strong style="color: #ffffff; display: block; margin-bottom: 4px;">Still having issues?</strong>
                <p style="color: rgba(255, 255, 255, 0.7); font-size: 14px; margin-bottom: 8px;">
                    Please call our support team at <span style="color: #00a8ff; font-weight: 600;">(208) 860-7824</span>.
                </p>
                <div style="font-size: 13px; color: rgba(255, 255, 255, 0.5);">
                    <i class="fa-regular fa-clock me-1"></i> Available 9:00 AM – 5:00 PM MT
                    <br>
                    <i class="fa-solid fa-shield-halved me-1 text-warning mt-1"></i> Note: Please have your <strong>FFL Number</strong> ready for verification.
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center mt-4">
        <button type="button" class="btn modern-btn primary-btn" style="min-width: 150px; height: 42px;" (click)="modalRef.hide()">
            Got it
        </button>
    </div>
</div>
